/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetEmailBodyDto
 */
export interface SetEmailBodyDto {
    /**
     * 
     * @type {string}
     * @memberof SetEmailBodyDto
     */
    emailPl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SetEmailBodyDto
     */
    emailEn?: string | null;
}

/**
 * Check if a given object implements the SetEmailBodyDto interface.
 */
export function instanceOfSetEmailBodyDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SetEmailBodyDtoFromJSON(json: any): SetEmailBodyDto {
    return SetEmailBodyDtoFromJSONTyped(json, false);
}

export function SetEmailBodyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetEmailBodyDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'emailPl': !exists(json, 'emailPl') ? undefined : json['emailPl'],
        'emailEn': !exists(json, 'emailEn') ? undefined : json['emailEn'],
    };
}

export function SetEmailBodyDtoToJSON(value?: SetEmailBodyDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'emailPl': value.emailPl,
        'emailEn': value.emailEn,
    };
}

